import {useState} from "react";
import {v4 as uuidv4} from 'uuid';

export const useUpdateToken : () => [string | undefined, () => void] = () => {
    const [token, setToken] = useState(undefined as string | undefined);
    return [token, () => setToken(uuidv4())];
}